export default __webpack_public_path__ + "static/media/BG-blue.bce8acda.png";